<template>
  <v-layout>
    <v-dialog v-model="editGroupNameModal" width="700">
      <v-card>
        <v-container>
          <v-layout row wrap justify-center align-center>
            <v-flex text-xs-center>
              <v-text-field v-model="groupToEdit.text"
                            class="v-input--is-focused blue--text" required></v-text-field>
            </v-flex>
            <v-flex xs12 text-xs-center>
              <v-btn color="green" dark small @click="editGroupName">Confirm</v-btn>
              <v-btn color="black" dark small @click="editGroupNameModal = false; groupToEdit = {};">Cancel</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteGroupModal" width="700">
      <v-card>
          <v-container>
            <v-layout row wrap justify-center align-center>
              <v-flex text-xs-center>
                <h3>Are you sure you want to delete <small>{{groupToDelete.class}}</small> "{{groupToDelete.text}}"?</h3>
                <p>ALL references to documents/sections in this group will be removed as well</p>
              </v-flex>
              <v-flex xs12 text-xs-left>
                <b>This will remove these references:</b>
                <ul>
                <li :class="item.class" v-for="item in groupToDelete.children">{{item.text}}
                  <ul v-if="item.children != undefined"><li v-for="subItem in item.children" :class="subItem.class">{{subItem.text}}</li></ul>
                </li>
                </ul>
                <br/><hr/><br/>
              </v-flex>
              <v-flex xs6 text-xs-left>
                <v-btn color="red" dark small @click="removeGroup">Confirm Delete</v-btn>
              </v-flex>
              <v-flex xs6 text-xs-right>
                <v-btn color="green" dark small @click="deleteGroupModal = false; groupToDelete = {};">Cancel</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
      </v-card>
    </v-dialog>
    <v-flex xs6 elevation-5 pa-3>
      <VueNestable
          :hooks="{
        'beforeMove': beforeMove
      }"
          v-model="items"
          cross-list
          group="cross"
          class-prop="class">
        <VueNestableHandle
            slot-scope="{ item }"
            :item="item"
        >


          <i class="v-icon material-icons">{{classToIcon(item.class)}}</i>
          {{item.text}}
          <v-btn v-if="item.class !== 'document' && item.children.length > 0" icon small>
            <v-icon @click="toggleSubContent($event)">arrow_drop_up</v-icon>
          </v-btn>

          <v-btn style="position: absolute; right: 35px;" right v-if="item.class !== 'document'" icon small>
            <v-icon @click="promptEditGroupName(item)">edit</v-icon>
          </v-btn>
          <v-btn style="position: absolute; right: 0;" right v-if="item.class !== 'document'" icon small>
            <v-icon @click="promptDeleteGroup(item)">delete</v-icon>
          </v-btn>
        </VueNestableHandle>
      </VueNestable>
    </v-flex>
    <v-flex  elevation-5 pa-3 md6 xs5 v-if="items.length > 0">
      <v-text-field ma-0 pa-0 name="search" label="Search" hint="Doc Search" value="Input text" v-model="docSearchText"
                    class="v-input--is-focused blue--text"></v-text-field>
      <VueNestable
          v-model="documentsSearchResult"
          cross-list
          group="cross"
      >
        <VueNestableHandle
            slot-scope="{ item }"
            :item="item"
        >
          <i class="v-icon material-icons">reorder</i>
          {{item.text}}
        </VueNestableHandle>
      </VueNestable>
    </v-flex>
  </v-layout>
</template>
<script>
import { VueNestable, VueNestableHandle } from 'vue-nestable'
import objectScan from 'object-scan'
import _ from "lodash";
const findNode = (id, input) => objectScan(['**'], {
  abort: true,
  rtn: 'value',
  filterFn: ({ value }) => value.id === id
})(input);
export default {
  name: 'DragDropLawGuide',
  props: ['dataset','bus'],
  data () {
    return {
      editGroupNameModal: false,
      deleteGroupModal: false,
      groupToEdit: {},
      groupToDelete: {},
      items: [],
      docSearchText: null,
      selectedChapter: null,
      catCounter:0,
      searchValue: '',
      dialog: false,
      title: 'School Law Guide Editor'
    }
  },
  mounted() {
    console.log('items mounted')
    this.items = this.dataset;
    this.bus.$on('newSubCat', this.newSubCat)
    this.bus.$on('newSection', this.newSection)
  },
  computed: {
    documentsAvailible(){
      let toReturn = []
      this.$serviceManuals.forEach((serviceManual)=>{
        if(findNode(serviceManual.id, this.items) == undefined) {
          toReturn.push({
            id: serviceManual.id,
            text: serviceManual.revnumber + ' ' + serviceManual.revtype + ' (' + serviceManual.citation + ')',
            class: 'document'
          })
        } else {
          //console.log('item in other list', serviceManual)
        }
      })
      return toReturn;
    },
    documentsSearchResult(){
      if(this.docSearchText != null && this.docSearchText.length > 2) {
        console.log('filtering')
        return this.documentsAvailible.filter(item => item.text.includes(this.docSearchText)).slice(0, 20);

      } else {
        return this.documentsAvailible.slice(0, 20);
      }
    },
  },
  watch: {
    items: _.debounce(function(newVal){
      this.$emit('changed', newVal)
    }, 250)
  },
  methods: {
    newSubCat(chapter, subCatName){
      this.items.push(
          {
            id: 'test' + Date.now(),
            group: 'subcat',
            class: "subcategory",
            parent: chapter,
            text: subCatName,
            children: [],
          }
      )
    },
    newSection(sectionCategory, sectionName){
      this.items.find((x)=>x.group == 'subcat' && x.id ==sectionCategory).children.push({
        id: 'test' + Date.now(),
        group: 'section',
        class: "section",
        parent: sectionCategory,
        text: sectionName,
        children: []
      })
    },
    editGroupName() {
      this.items.find((x)=>x.id == this.groupToEdit.id).text = this.groupToEdit.text
      this.editGroupNameModal = false
      this.groupToEdit = {}
    },
    removeGroup(){
      const index = this.items.indexOf(this.groupToDelete);
      if (index > -1) {
        this.items.splice(index, 1);
      }
      this.deleteGroupModal = false
      this.groupToDelete = {}
    },
    promptEditGroupName(group) {
      this.groupToEdit = group
      this.editGroupNameModal = true
    },
    promptDeleteGroup(group){
      this.groupToDelete = group
      this.deleteGroupModal = true
    },
    toggleSubContent(event) {
      console.log('toggled',event.target.parentNode.closest('.nestable-item').querySelector('.nestable-list'))
      event.target.classList.toggle('downIsUp')
      event.target.parentNode.closest('.nestable-item').querySelector('.nestable-list').classList.toggle('is-collapsed');
    },
    classToIcon(className) {
      switch (className){
        case 'section': return 'subdirectory_arrow_right';
        case 'document': return 'gavel';
        case 'subcategory' : return 'folder';
        default: return 'reorder'
      }
    },
    getNewCatTemplate(){
      var toReturn ={ key: 'newCat' + this.catCounter, text: "New Sub Category", class: "newCat" }
      this.catCounter++
      return toReturn
    },
    beforeMove ({ dragItem, pathFrom, pathTo }) {
      console.log('dragitem', pathTo)
      return true;
       if(dragItem.class == 'document') {
        return pathTo.length > 1
      } else if(dragItem.class == 'section') {
         return pathTo.length == 2
      }  else if(dragItem.class == 'subcategory') {
        return pathTo.length == 1
      }
      // All other items can be
      return true
    }
  },
  components: {
    VueNestable,
    VueNestableHandle
  },
}
</script>
<style>

.nestable-handle > i {
  line-height: 21px;
  margin-left: 5px;
}
.nestable-item.subcategory > .nestable-item-content{
  background-color: #e0e0e0;
}
.nestable-item.section > .nestable-item-content{
  background-color: #e0e0e0;
}

.nestable-item.subcategory .nestable-item-content > .nestable-handle,
.nestable-item.section .nestable-item-content > .nestable-handle{
  line-height: 40px;
}
.v-icon.downIsUp{
  transform: rotateX(
      180deg);
}
.nestable-list.is-collapsed {
display: none;
}
.nestable-handle {
  display: inline-block;
}
.nestable .nestable-list {
  margin: 0;
  padding: 0 0 0 40px;
  list-style-type: none;
}
.subcategory {
  color: #415ad4;
}
.document {
  color: #b43ceb;
}
.section {
  color: #e13a3a;
}


.nestable {
  position: relative;
}
.nestable-rtl {
  direction: rtl;
}
.nestable .nestable-list {
  margin: 0;
  padding: 0 0 0 40px;
  list-style-type: none;
}
.nestable-rtl .nestable-list {
  padding: 0 40px 0 0;
}
.nestable > .nestable-list {
  padding: 0;
}
.nestable-item,
.nestable-item-copy {
  margin: 10px 0 0;
}
.nestable-item:first-child,
.nestable-item-copy:first-child {
  margin-top: 0;
}
.nestable-item .nestable-list,
.nestable-item-copy .nestable-list {
  margin-top: 10px;
}
.nestable-item {
  position: relative;
}
.nestable-item.is-dragging .nestable-list {
  pointer-events: none;
}
.nestable-item.is-dragging * {
  opacity: 0;
  filter: alpha(opacity=0);
}
.nestable-item.is-dragging:before {
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(106, 127, 233, 0.274);
  border: 1px dashed rgb(73, 100, 241);
  -webkit-border-radius: 5px;
  border-radius: 5px;
}
.nestable-drag-layer {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  pointer-events: none;
}
.nestable-rtl .nestable-drag-layer {
  left: auto;
  right: 0;
}
.nestable-drag-layer > .nestable-list {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0;
  background-color: rgba(106, 127, 233, 0.274);
}
.nestable-rtl .nestable-drag-layer > .nestable-list {
  padding: 0;
}
.nestable [draggable="true"] {
  cursor: move;
}
.nestable-handle {
  display: inline;
}
</style>
